import theme, { ThemeValue } from 'styled-theming';

export type ThemeName = 'light' | 'dark';

export const buildPalette = <T extends Record<string, string>>(palettes: {
  light: T;
  dark: T;
  fallback?: Partial<T>;
}) => {
  const themedValue = (
    lightValue: ThemeValue,
    darkValue: ThemeValue,
    fallback?: ThemeValue
  ) =>
    theme('name', {
      light: lightValue,
      dark: darkValue,
      default: fallback ?? lightValue,
    });

  return (key: keyof T) =>
    themedValue(
      palettes.light[key],
      palettes.dark[key],
      palettes.fallback?.[key] ?? palettes.light[key]
    );
};
